import React, {
  FunctionComponent,
  useContext,
  useEffect,
  useState,
} from 'react';
import { TOURIST_SERVICE_TYPE } from '../../../shared/constants';
import { splitField, splitFieldForms } from '../../../shared/utils';
import serviceDetailBaseStyles from '../../../styles/atoms/service-detail-base.module.scss';
import { GeneralConfigContext } from '../../general-config-provider';
import LocationFormField from '../location-form-field';
import ServicesListFormField from '../services-list-form-field';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';

type AccommodationPreviewProps = {
  detailData: any;
};

export const AccommodationPreview: FunctionComponent<
  AccommodationPreviewProps
> = ({ detailData }) => {
  const { generalConfig } = useContext(GeneralConfigContext);
  const t = useTranslations('viewOffer');
  const router = useRouter();
  const [locale, setLocale] = useState(router?.locale);

  useEffect(() => {
    if (router.locale) {
      setLocale(router?.locale);
    }
  }, [router?.locale]);
  return (
    <div className={serviceDetailBaseStyles.detailContainer}>
      <p>
        {t('tipoAlojamiento')}{' '}
        <strong>
          {locale === 'en'
            ? generalConfig?.tipo_alojamiento.find(
                (type) =>
                  type.id_tipo_alojamiento === detailData.id_tipo_alojamiento
              ).en_nombre
            : generalConfig?.tipo_alojamiento.find(
                (type) =>
                  type.id_tipo_alojamiento === detailData.id_tipo_alojamiento
              ).nombre}
        </strong>
      </p>

      <LocationFormField value={detailData.ubicacion} viewOnly={true} />

      {detailData?.servicio_adicional_alojamiento.length > 0 && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('incluye')}</p>
          <ServicesListFormField
            value={detailData?.servicio_adicional_alojamiento}
            viewOnly={true}
            touristServiceType={TOURIST_SERVICE_TYPE.ACCOMMODATION}
          />
        </div>
      )}

      {splitField(detailData?.informacion_adicional, locale) !== '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('informacionAdicional')}</p>
          <p>{splitField(detailData?.informacion_adicional, locale)}</p>
        </div>
      )}
    </div>
  );
};
